export enum ErrorType {
  ERROR401 = 'Unauthorized',
  ERROR403 = 'Forbidden. Your account does not have sufficient credentials to perform this action.',
  ERROR404 = 'Not Found',
  ERROR429 = 'Please Try Again',
  ERROR500 = 'Something went wrong. Please try again later.',
  NETWORKERROR = 'There was a problem contacting the service. Please try again.',
  DEFAULT = 'Something went wrong. Please try again later.',
}
